export function getFileNameAndExtension(url: string) {
  try {
    const parsedUrl = new URL(url);
    const { pathname } = parsedUrl;
    const lastSegment = pathname.split('/').pop();

    if (lastSegment && lastSegment.includes('.')) {
      const [name, ...extParts] = lastSegment.split('.');
      const extension = extParts.join('.');
      return {
        name,
        extension,
      };
    }
    return {
      name: 'Documento',
      extension: '',
    };
  } catch (e) {
    return {
      name: 'Documento',
      extension: '',
    };
  }
}
